import { createContext } from 'react'; //3K (gzipped : 1.4k)

const UserContext = createContext(null)
export default UserContext